import ProductAjaxService from "./ProductAjaxService";

export default class FavoriteActions extends ProductAjaxService {
    constructor() {
        super();
        this.addToFavorite();
        this.removeFromFavorite();
        this.removeFromFavoriteArr();
        this.removeFavoriteList();
    }

    //After load page
    getFavorites() {
        this._GET(this.getSmallFavUrl, this.updateSmallCarts);
    }

    addToFavorite() {
        let self = this;
        $(document).on('click', '.add_to_favorite:not(.active)', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }

            self._POST(self.addToFavoriteUrl, {product_id: ID}, self.updateSmallCarts);

            let $favItem = $('.add_to_favorite[data-id='+ ID +']');
            $favItem.addClass('active');
            $favItem.find('.icon').removeClass('icon-bookmark').addClass('icon-bookmark_on');
        });
    }

    //Single remove
    removeFromFavorite() {
        let self = this;
        $(document).on('click', '.add_to_favorite.active, .remove_fav_single', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id'),
                category_id = $(this).attr('data-category') ? $(this).attr('data-category') : null;
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }

            if(category_id) {
                self._POST(self.delFromFavoriteUrl, {product_ids: [ID], category_id: category_id}, self.updateSmallCarts);
            } else {
                self._POST(self.delFromFavoriteUrl, {product_ids: [ID]}, self.updateSmallCarts);
            }

            let $favItem = $('.add_to_favorite[data-id='+ ID +']');
            $favItem.removeClass('active');
            $favItem.find('.icon').removeClass('icon-bookmark_on').addClass('icon-bookmark');
        });
    }
    //Arr remove
    removeFromFavoriteArr() {
        let self = this;
        $(document).on('click', '.remove_fav_ids', function (e) {
            e.preventDefault();
            let IDS = $(this).attr('data-ids'),
                category_id = $(this).attr('data-category') ? $(this).attr('data-category') : null;
            if(!IDS) {
                console.warn('Please set product ID');
                return false;
            }

            self._POST(self.delFromFavoriteUrl, {product_ids: IDS, category_id: category_id}, self.updateSmallCarts);

            IDS.split(',').forEach(function (item) {
                let $favItem = $('.add_to_favorite[data-id=' + item + ']');
                $favItem.removeClass('active');
                $favItem.find('.icon').removeClass('icon-bookmark_on').addClass('icon-bookmark');
            });
        });
    }

    //Profile page
    removeFavoriteList() {
        let self = this;
        $(document).on('click', '.remove_fv_list', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id'),
                confName = 'confirm:delete';
            if(!ID) {
                console.warn('Please set list ID');
                return false;
            }

            $(document).bind(confName, function () {
                $(document).unbind(confName);
                self._POST(self.delFavoriteListUrl, {list_id: ID}, self.updateSmallCarts);

                //Remove from popup list
                $('#change_fav_list input[value="'+ ID +'"]').closest('.form-group').remove();
            });
            self.confirmDelete(confName, true);
        });
    }


    updateSmallCarts(res) {
        if(res.success) {
            //Big list
            if(res.data["html"] !== undefined && res.data.html["big"] !== undefined) {
                $('#xhr-fav-big-list').html(res.data.html.big);
            }

            //Small
            if(res.data["html"] !== undefined && res.data.html["small"] !== undefined) {
                $('.ajax_small_items_favorite').html(res.data.html.small.html);
                if(res.data.html.small.count && res.data.html.small.count > 0 || res.data.html.small.count === null) {

                    $('.ajax_content_fav_true .title span, .open_swipe .fav_icon + span strong').html(res.data.html.small.count);
                    $('.ajax_content_fav_true').show();
                    $('.ajax_content_fav_false').hide();

                    $('.hover_item .fav_icon, .open_swipe .fav_icon')
                        .removeClass('icon-bookmark')
                        .addClass('icon-bookmark_on')
                        .parent().addClass('icon_indicator');

                } else {
                    $('.ajax_content_fav_true').hide();
                    $('.ajax_content_fav_false').show();

                    $('.hover_item .fav_icon, .open_swipe .fav_icon')
                        .addClass('icon-bookmark')
                        .removeClass('icon-bookmark_on')
                        .parent().removeClass('icon_indicator');

                }
            }

            if($(window).width() >= 1200) {
                $('.ajax_small_items_favorite').scrollbar();
            }

            //Calculate in profile list
            if($('.favorites_list').length) {
                $(document).trigger('fav.calculate.products');
            }
        }
    };


}
